module.exports = __webpack_public_path__ + "static/media/flower-border.838c00d6.png";